import { styled } from '@mui/material';

export const ErrorWrapper = styled('div')(({ theme }) => ({
  color: theme.palette.error.main,
}));

export const EmptyData = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  margin: `${theme.spacing(1)} 0`,
}));
